// Jediný zdroj firemních údajů – texty i komponenty berou čísla odsud,
// aby se už nemohly rozejít (dřív se lišil rok založení, počet lidí i adresa).
export const COMPANY = {
  name: 'KOVOJOCH s.r.o.',
  founded: 2002,
  hallYear: 2014,
  employees: 21,
  phone: '+420 604 615 622',
  phoneHref: 'tel:+420604615622',
  email: 'kovojoch@seznam.cz',
  address: 'V Zahrádkách 2193/7, 568 02 Svitavy',
  ico: '05599890',
  dic: 'CZ05599890',
  mapsUrl:
    'https://www.google.com/maps/place/Kovo+Joch+CNC+Obr%C3%A1b%C4%9Bn%C3%AD/@49.7551936,16.4815656,351m/data=!3m1!1e3!4m6!3m5!1s0x470d8bd9a3dd05d7:0x4f9b3cfb45f3d2e7!8m2!3d49.7555479!4d16.481578!16s%2Fg%2F1tfd135f',
  mapsEmbed:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3057.569981703988!2d16.478754876797073!3d49.75555363715363!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470d8a2c2d860083%3A0xb58c8fcbba86ce32!2zViBaYWhyw6Fka8OhY2ggMjE5My83LCA1NjggMDIgU3ZpdGF2eSAyLVDFmWVkbcSbc3TDrQ!5e1!3m2!1scs!2scz!4v1735773520758!5m2!1scs!2scz',
};

// Kontaktní osoby – pozice se překládají přes contact.roles.<role>.
export const TEAM = [
  { name: 'Antonín Joch', role: 'ceo', email: 'kovojoch@seznam.cz', phone: '+420 604 615 622' },
  { name: 'Ing. Iva Malá', role: 'admin', email: 'i.mala@kovojoch.cz', phone: '+420 605 443 376' },
  { name: 'Ladislav Harašta', role: 'foreman', email: 'l.harasta@kovojoch.cz', phone: '+420 733 539 817' },
  { name: 'Jiří Kodytek', role: 'programmer', email: 'j.kodytek@kovojoch.cz', phone: '+420 736 164 538' },
  { name: 'Martin Šimerle', role: 'shipping', email: 'expedice@kovojoch.cz', phone: '+420 773 686 771' },
];

// Roky k textům v překladech (history.events) – pořadí musí sedět.
export const TIMELINE_YEARS = ['2002', '2004', '2007', '2010', '2014', '2016', '2016', '2018', '2024'];
